var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:"copyright"},[_vm._v("Copyright © PecSmart "+_vm._s(_vm.year))])])}
var staticRenderFns = []

export { render, staticRenderFns }